export default __webpack_public_path__ + "static/media/team_carousel0.png";